var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 3.33311V7.49978H3.81825M3.81825 7.49978C4.37146 6.13155 5.36299 4.98553 6.63744 4.24133C7.9119 3.49712 9.39725 3.19679 10.8607 3.38739C12.3242 3.578 13.6831 4.24877 14.7244 5.29459C15.7657 6.34041 16.4306 7.70216 16.6149 9.16644M3.81825 7.49978H7.49992M16.6666 16.6664V12.4998H16.1824M16.1824 12.4998C15.6284 13.8672 14.6366 15.0123 13.3623 15.7559C12.0879 16.4994 10.603 16.7994 9.14 16.6088C7.67697 16.4183 6.31842 15.748 5.27703 14.7029C4.23564 13.6578 3.57021 12.2968 3.38492 10.8331M16.1824 12.4998H12.4999",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon_refresh.bfed5011b6ca3991328a964ce24d0b40.svg";
export { ForwardRef as ReactComponent };